import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { MainStep } from '@/views/Automation/CampaignCreatorV2/types';
import { computed } from 'vue';

interface Props {
  activeStep: MainStep;
  steps: MainStep[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcSteps.ts',
  props: {
    activeStep: { default: MainStep.CREATE_CAMPAIGN },
    steps: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { activeStep: MainStep, steps: MainStep[] };



const activeStepPosition = computed(() => props.steps.indexOf(props.activeStep));

return { __sfc: true,props, activeStepPosition, CcIcon }
}

})